import { useToast } from "@/hooks/use-toast"
import { texteLisible } from "@/lib/erreur"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {/* Tout ce qui s'affiche ici passe par `texteLisible`. Un 422 de
                  FastAPI porte une LISTE D'OBJETS dans `detail`, que les
                  écrans posent tels quels : dans du JSX, ça lève « Objects are
                  not valid as a React child » — et comme ce bandeau est monté
                  à la racine, c'est toute l'application qui blanchit. Un refus
                  juste ne doit pas éteindre l'écran. */}
              {title && <ToastTitle>{texteLisible(title)}</ToastTitle>}
              {description && (
                <ToastDescription>{texteLisible(description)}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
